var path = 'src/app/forms/fields/integer-field.html';
var html = "<div ng-class=\"{'input-group': units}\"> <input frm-model frm-required integer-validator ng-required=required() ng-model=model type=text class=form-control /> <span ng-if=units class=input-group-addon>{{units}}</span></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/integer-field.html
 ** module id = 277
 ** module chunks = 0
 **/